export default __webpack_public_path__ + "static/media/3DShape_02.440bc438.png";